/* Peakside Facelift 2026 — header (WP1 pk-header).
   Drawer close control: `[data-pk-drawer-close]` inside <header-drawer> closes the menu drawer
   through Dawn's own HeaderDrawer.closeMenuDrawer (global.js) and returns focus to the summary.
   Capture phase so it runs before MenuDrawer's generic `button` binding (which only closes a
   submenu and is harmless on the main drawer). */
(function () {
  'use strict';

  function onDocumentClick(event) {
    var trigger = event.target && event.target.closest ? event.target.closest('[data-pk-drawer-close]') : null;
    if (!trigger) return;

    var drawer = trigger.closest('header-drawer');
    if (!drawer) return;

    var summary = drawer.querySelector('summary');
    event.preventDefault();

    if (typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(event, summary);
    } else {
      var details = drawer.querySelector('details');
      if (details) details.removeAttribute('open');
    }

    if (summary) summary.focus();
  }

  document.addEventListener('click', onDocumentClick, true);
})();
